import { makeGraphQLRequest } from '../../utils/requestUtils';

export async function getOrgByID(id) {
  // Format Query
  const query = `query organization(
    $id: ID
  ) {
    organization(id: $id) {
     
      cageCode
     
      }
    }`;

  const variables = { id };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function getOrganizationList(id = 'approved') {
  const query = `query organizationForMessages(
    $id: String
  ) {
    organizationForMessages(id: $id)  {  LimitedOrganizations{ name cageCode } 
  }
    }`;

  const variables = { id };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  if (
    response.organizationForMessages &&
    response.organizationForMessages.LimitedOrganizations
  ) {
    return response.organizationForMessages.LimitedOrganizations;
  }
  return {};
}



// WEBPACK FOOTER //
// ./src/pages/ComposeMessage/graphql.js